<script setup lang="ts">
import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import type SiteTopBanner from '@store/content/entities/SiteTopBanner';

const { banner } = defineProps<{
    banner: SiteTopBanner;
}>();
const hide = ref(true);
const hideClose = computed(() => banner.closeAction === 'none');
const onClose = () => {
    hide.value = true;
    if (banner.closeAction === 'closeOnce') {
        const topBannerClosedList = JSON.parse(
            sessionStorage.getItem('topBannerClosedList') || '[]'
        ) as string[];
        topBannerClosedList.push(banner.id);
        sessionStorage.setItem(
            'topBannerClosedList',
            JSON.stringify(topBannerClosedList)
        );
    } else if (banner.closeAction === 'closeAlways') {
        const topBannerClosedList = JSON.parse(
            localStorage.getItem('topBannerClosedList') || '[]'
        ) as string[];
        topBannerClosedList.push(banner.id);
        localStorage.setItem(
            'topBannerClosedList',
            JSON.stringify(topBannerClosedList)
        );
    }
};
onMounted(() => {
    const closeAlways = JSON.parse(
        localStorage.getItem('topBannerClosedList') || '[]'
    ) as string[];
    const closeOnce = JSON.parse(
        sessionStorage.getItem('topBannerClosedList') || '[]'
    ) as string[];
    hide.value = [...closeAlways, ...closeOnce].includes(banner.id);
});

function openUrl() {
    if (banner?.link) {
        window.open(banner.link, '_blank');
    }
}
</script>

<template>
    <div
        class="banner-container"
        :class="{
            'mobile-only': !banner.desktopImage,
            'desktop-only': !banner.mobileImage,
            hide,
            clickable: banner.link,
        }"
        @click="openUrl"
    >
        <mr-button
            v-if="!hideClose"
            variant="transparent"
            class="close-button"
            :icon-button="faXmark"
            @click.prevent.stop="onClose"
        />
        <mr-blur-hash-image
            v-if="banner.desktopImage"
            class="desktop-only"
            :src="banner.desktopImage.src"
            :hash="banner.desktopImage.blurHash"
            image-fit="cover"
            hide-blurhash-onload
            preload
        />
        <mr-blur-hash-image
            v-if="banner.mobileImage"
            class="mobile-only"
            :hash="banner.mobileImage.blurHash"
            :src="banner.mobileImage.src"
            image-fit="cover"
            hide-blurhash-onload
            preload
        />
    </div>
</template>

<style lang="scss" scoped>
.clickable {
    cursor: pointer;
}
.banner-container {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100vw;
    height: 60px;
    transition: all 200ms linear;
    :deep(img) {
        width: 100%;
        height: 60px;
        object-fit: cover;
    }

    &.hide {
        height: 0;
        visibility: hidden;
    }
}

.close-button {
    position: absolute;
    z-index: 100;
    left: 12px;
    top: -4px;
}

@media (max-width: $app-mobile-max-width) {
    .banner-container {
        height: 50px;
        :deep(img) {
            height: 50px;
        }
    }
}
</style>
